import { render, staticRenderFns } from "./BookingPolicyPopup.vue?vue&type=template&id=4db35186&scoped=true"
import script from "./BookingPolicyPopup.vue?vue&type=script&lang=js"
export * from "./BookingPolicyPopup.vue?vue&type=script&lang=js"
import style0 from "./BookingPolicyPopup.vue?vue&type=style&index=0&id=4db35186&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db35186",
  null
  
)

export default component.exports